var d = new Date();
var n = d.getDay();
var now = d.getHours() + "." + d.getMinutes();
var weekdays = [
    ["Sunday"],
    ["Monday"],
    ["Tuesday", 10.00, 18.00],
    ["Wednesday", 10.00, 18.00],
    ["Thursday", 10.00, 18.00],
    ["Friday", 10.00, 18.00],
    ["Saturday", 10.00, 16.00],
];
var day = weekdays[n];
if (now > day[1] && now < day[2] || now > day[3] && now < day[4]) {
    document.getElementsByClassName("openeninghrs block closed")[0].style.display="none";
    document.getElementsByClassName("openeninghrs block open")[0].style.display="flex";
}
 else {
    document.getElementsByClassName("openeninghrs block closed")[0].style.display="flex";
    document.getElementsByClassName("openeninghrs block open")[0].style.display="none";
}